import { fromJS } from 'immutable';
export var SET_LOGISTICS_UNFINISHED = 'line-dashboard/SET_LOGISTICS_UNFINISHED';
export var SET_LOGISTICS_UNFINISHED_SORT = 'line-dashboard/SET_LOGISTICS_UNFINISHED_SORT';
export var SET_LOGISTICS_TERMINAL_UNFINISHED = 'line-dashboard/SET_LOGISTICS_TERMINAL_UNFINISHED';
export var SET_LOGISTICS_TERMINAL_UNFINISHED_SORT = 'line-dashboard/SET_LOGISTICS_TERMINAL_UNFINISHED_SORT';
export var SET_LOGISTICS_FORECAST = 'line-dashboard/SET_LOGISTICS_FORECAST';
export var SET_LOGISTICS_FORECAST_SORT = 'line-dashboard/SET_LOGISTICS_FORECAST_SORT';
export var SET_LOGS_TERMINALS = 'line-dashboard/SET_LOGS_TERMINALS';
export var SET_LOGS_TERMINALS_SORT = 'line-dashboard/SET_LOGS_TERMINALS_SORT';
export var SET_ZONESLIST = 'line-dashboard/SET_ZONESLIST';
export var SET_TERMINALSLIST = 'line-dashboard/SET_TERMINALSLIST';
export var SET_T_TERMINALSLIST = 'line-dashboard/SET_T_TERMINALSLIST';
export var SET_CY_TERMINALSLIST = 'line-dashboard/SET_CY_TERMINALSLIST';
export var SET_LOGISTICS_LIST = 'line-dashboard/SET_LOGISTICS_LIST';
export var RESET = 'line-dashboard/RESET';
export var setLogisticsUnfinished = function setLogisticsUnfinished(data) {
  return {
    type: SET_LOGISTICS_UNFINISHED,
    data: data
  };
};
export var setLogisticsUnfinishedSort = function setLogisticsUnfinishedSort(sort) {
  return {
    type: SET_LOGISTICS_UNFINISHED_SORT,
    sort: sort
  };
};
export var setLogisticsTerminalUnfinished = function setLogisticsTerminalUnfinished(data) {
  return {
    type: SET_LOGISTICS_TERMINAL_UNFINISHED,
    data: data
  };
};
export var setLogisticsTerminalUnfinishedSort = function setLogisticsTerminalUnfinishedSort(sort) {
  return {
    type: SET_LOGISTICS_TERMINAL_UNFINISHED_SORT,
    sort: sort
  };
};
export var setLogisticsForecast = function setLogisticsForecast(data) {
  return {
    type: SET_LOGISTICS_FORECAST,
    data: data
  };
};
export var setLogisticsForecastSort = function setLogisticsForecastSort(sort) {
  return {
    type: SET_LOGISTICS_FORECAST_SORT,
    sort: sort
  };
};
export var setLogsTerminals = function setLogsTerminals(data) {
  return {
    type: SET_LOGS_TERMINALS,
    data: data
  };
};
export var setLogsTerminalsSort = function setLogsTerminalsSort(sort) {
  return {
    type: SET_LOGS_TERMINALS_SORT,
    sort: sort
  };
};
export var setZonesList = function setZonesList(data) {
  return {
    type: SET_ZONESLIST,
    data: data
  };
};
export var setTerminalsList = function setTerminalsList(data) {
  return {
    type: SET_TERMINALSLIST,
    data: data
  };
};
export var setTTerminalsList = function setTTerminalsList(data) {
  return {
    type: SET_T_TERMINALSLIST,
    data: data
  };
};
export var setCyTerminalsList = function setCyTerminalsList(data) {
  return {
    type: SET_CY_TERMINALSLIST,
    data: data
  };
};
export var setLogisticsList = function setLogisticsList(data) {
  return {
    type: SET_LOGISTICS_LIST,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  logisticsUnfinished: [],
  logisticsTerminalUnfinished: [],
  logisticsForecast: [],
  logsTerminals: [],
  // table sort
  logisticsUnfinishedSort: {
    field: 'estBeginTime',
    desc: false
  },
  logisticsTerminalUnfinishedSort: {
    field: 'estBeginTime',
    desc: false
  },
  logisticsForecastSort: {
    field: 'estBeginTime',
    desc: false
  },
  logsTerminalsSort: {
    field: 'entryTime',
    desc: true
  },
  // dropdown list
  zonesList: [],
  terminalsList: [],
  tTerminalsList: [],
  cyTerminalsList: [],
  logisticsList: []
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_LOGISTICS_UNFINISHED:
      return state.set('logisticsUnfinished', action.data);

    case SET_LOGISTICS_UNFINISHED_SORT:
      return state.set('logisticsUnfinishedSort', action.sort);

    case SET_LOGISTICS_TERMINAL_UNFINISHED:
      return state.set('logisticsTerminalUnfinished', action.data);

    case SET_LOGISTICS_TERMINAL_UNFINISHED_SORT:
      return state.set('logisticsTerminalUnfinishedSort', action.sort);

    case SET_LOGISTICS_FORECAST:
      return state.set('logisticsForecast', action.data);

    case SET_LOGISTICS_FORECAST_SORT:
      return state.set('logisticsForecastSort', action.sort);

    case SET_LOGS_TERMINALS:
      return state.set('logsTerminals', action.data);

    case SET_LOGS_TERMINALS_SORT:
      return state.set('logsTerminalsSort', action.sort);

    case SET_ZONESLIST:
      return state.set('zonesList', action.data);

    case SET_TERMINALSLIST:
      return state.set('terminalsList', action.data);

    case SET_T_TERMINALSLIST:
      return state.set('tTerminalsList', action.data);

    case SET_CY_TERMINALSLIST:
      return state.set('cyTerminalsList', action.data);

    case SET_LOGISTICS_LIST:
      return state.set('logisticsList', action.data);

    case RESET:
      return initialState;

    default:
      return state;
  }
}